import React from 'react';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import { TravelerProfile } from '@marageti/z4-sdk/lib/people';
import { useMediaQuery, useTheme } from '@mui/material';
import { useParams } from 'react-router-dom';
import InfoPanelView from './info-panel-view';
import { useAuthStore } from '../../../../store';

const InfoPanelContainer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('desktop'));
  const { tripRequestId } = useParams();
  const apiClient = useApiClient();
  const tripRequest = useFetch<TripRequest>(apiClient.tripRequestsClient.getTripRequest, [tripRequestId], !!tripRequestId);
  const { loggedInTeamMember } = useAuthStore();
  const travelerProfile = useFetch<TravelerProfile>(apiClient.peopleClient.getTravelerProfile, [tripRequest.data?.travelers[0].id], (!isMobile && !!tripRequest.data?.travelers[0].id));

  return (
    <InfoPanelView
      error={tripRequest.error || travelerProfile.error}
      loggedInTeamMember={loggedInTeamMember}
      isLoading={tripRequest.isLoading || travelerProfile.isLoading}
      isMobile={isMobile}
      travelers={tripRequest.data?.travelers}
      tripRequest={tripRequest.data}
    />
  );
};

export default InfoPanelContainer;
